
import SitePal from './SitePal.vue';


export default SitePal;